import wx from 'weixin-js-sdk'
import router from '../router'
import { WxPage } from '../enum'
import { getLocal, getUrlQuery } from '@/common/js/utils'
import Qs from 'qs'

export default () => {
  // 获取环境状态
  const isMiniProgram = () => {
    return new Promise(resolve => {
      let ua = navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        wx.miniProgram.getEnv(res => {
          if (res.miniprogram) {
            resolve(true)
          } else {
            resolve(false)
          }
        })
      } else {
        resolve(false)
      }
    })
  }

  const isInWxapp = getLocal('platform') === 'mini'
  const navigateTo = (url, data) => {
    const wxurl = `${WxPage.copy}?url=${encodeURIComponent(url)}`
    isInWxapp && wx.miniProgram.navigateTo({ url: wxurl })
    isInWxapp && wx.miniProgram.postMessage({ data: { url } })
    !isInWxapp && router.push(url)
  }
  const navigateToH5 = url => {
    const wxurl = `${WxPage.h5}?url=${encodeURIComponent(url)}`
    isInWxapp && wx.miniProgram.navigateTo({ url: wxurl })
    !isInWxapp && window.open(url, '_blank')
  }
  const switchTab = (url, data) => {
    const wxurl = `${WxPage.copy}?url=${encodeURIComponent(url)}`
    isInWxapp && wx.miniProgram.switchTab({ url: wxurl })
    isInWxapp && wx.miniProgram.postMessage({ data: { url } })
    !isInWxapp && router.push(wxurl)
  }
  const switchTabWx = (url, data) => {
    isInWxapp && wx.miniProgram.switchTab({ url })
  }
  const goWxAppPage = url => {
    isInWxapp && wx.miniProgram.navigateTo({ url })
  }
  const redirectTo = (url, data) => {
    const wxurl = `${WxPage.copy}?url=${encodeURIComponent(url)}`
    isInWxapp && wx.miniProgram.redirectTo({ url: wxurl })
    isInWxapp && wx.miniProgram.postMessage({ data: { url, data } })
    !isInWxapp && router.push({ path: url, query: Qs.parse(getUrlQuery(url)), replace: true })
  }
  const navigateBack = (data, url, delta = 1) => {
    if (isInWxapp) {
      wx.miniProgram.navigateBack({ delta })
      wx.miniProgram.postMessage({ data: { data, url } })
    } else {
      url ? router.push(url) : router.go(-delta)
    }
  }
  const navigateToLogin = () => {
    isInWxapp && wx.miniProgram.redirectTo({ url: WxPage.login })
    !isInWxapp && router.replace('/login')
  }
  const redirectToHome = data => {
    isInWxapp && wx.miniProgram.redirectTo({ url: WxPage.home })
    isInWxapp && wx.miniProgram.postMessage({ data: { url: '/home', data } })
    !isInWxapp && router.replace('/home')
  }
  const switchTabMain = data => {
    isInWxapp && wx.miniProgram.switchTab({ url: WxPage.main })
    isInWxapp && wx.miniProgram.postMessage({ data: { url: '/home', data } })
    !isInWxapp && router.replace('/home')
  }
  const getFixHeight = () => {
    return isInWxapp ? { height: '100vh' } : { height: 'calc(100vh - 44px)' }
  }

  return {
    isMiniProgram,
    navigateTo,
    switchTab,
    redirectTo,
    navigateBack,
    getFixHeight,
    switchTabWx,
    redirectToHome,
    switchTabMain,
    goWxAppPage,
    navigateToLogin,
    navigateToH5
  }
}
